import { useCallback, useState, useContext } from "react";
import { useHistory } from "react-router-dom";
import AuthContext from "../context/AuthContext";

const useHttp = () => {
    const { logout } = useContext(AuthContext);
    const history = useHistory()

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const clearError = useCallback(() => setError(null), []);

    const request = useCallback(async (url, method = 'GET', body = null, headers = {}, disableLoading = false) => {
        if (!disableLoading) {
            setLoading(true);
        }

        try {
            if (body) {
                body = JSON.stringify(body);
                headers['Content-Type'] = 'application/json';
            }

            const response = await fetch(url, { method, body, headers });

            if (response.status === 401) {
                logout();
                history.push('/');
            }

            if (!response.ok) {
                let message;

                try {
                    const decodedResponse = await response.json();
                    message = decodedResponse.message;
                } catch { }

                throw new Error(message || "Something went wrong")
            }

            const data = await response.json();

            setLoading(false);

            return data;
        } catch (e) {
            setLoading(false);
            setError(e.message);
            throw e;
        }
    }, []);

    const uploadRequest = useCallback(async (url, body = null, headers = {}) => {
        setLoading(true);

        try {
            const response = await fetch(url, { method: "POST", body, headers });

            if (response.status === 401) {
                logout();
                history.push('/');
            }

            if (!response.ok) {
                setLoading(false);
                throw new Error(response.message || "Something went wrong")
            }

            const data = await response.json();

            setLoading(false);

            return data;
        } catch (e) {
            setLoading(false);
            setError(e.message);
            throw e;
        }
    }, []);

    return { loading, request, uploadRequest, error, clearError }
}

export default useHttp;